module.exports = __webpack_public_path__ + "img/food_icecream.dccd5243.png";